import CardCommon from '@op/components/CardCommon';
import { tableIcon, lineIcon, barIcon } from '@op/constants/chart';
import React, { useState } from 'react';
import { mentionsSentimentTab, MentionsSentimentTabType } from '../constants';
import useLanguage from '@op/hooks/useLanguage';
import { Segment } from 'tea-component';
import MentionsSentimentCharts from './MentionsSentimentCharts';
import MentionsSentimentTable from './MentionsSentimentTable';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { SortBy } from 'tea-component/lib/table/addons';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function MentionsSentiment({
  filter,
  gameData,
  wholeGameInfo,
}: {
  filter: any;
  gameData: any;
  wholeGameInfo: any;
}) {
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [value, setValue] = useState<MentionsSentimentTabType>('mentions');
  const [chartType, setChartType] = useState('line');
  const [sortBy, setSortBy] = useState<SortBy<any>>({
    by: 'time',
    order: 'desc',
  });

  const { downloadLegacy, downloading } = useDownloadParams();

  return (
    <CardCommon
      className="scroll-margin-top-target"
      id="Mentions & Sentiment"
      title={formatMessage({ id: 'Mentions & Sentiment' })}
    >
      <CardCommon
        title={
          <Segment
            value={value}
            onChange={(value: MentionsSentimentTabType) => {
              setValue(value);
              buriedBtnPoint('CKMS_MetricsTAB', value);
            }}
            options={formatOptionsMessage(mentionsSentimentTab)}
          />
        }
        hasDownload
        contentCard
        downloadLoading={downloading}
        operations={[tableIcon, lineIcon, barIcon]}
        defaultOperation={chartType}
        handleOperationsOnClick={(item) => {
          setChartType(item?.symbol || 'line');
        }}
        handleDownloadOnClick={() => {
          const downloadLimit = 10000;

          const downLoadParams = {
            ...filter,
            stats_types: ['mentions_sentiment'],
            tab_type: value,
            sort: sortBy,
            gameData,
          };
          const gameName = wholeGameInfo?.entity_name || '';
          const fileName = `${gameName} Compare Key Metrics - DataBrain Opinions`;
          downloadLegacy({
            limit: downloadLimit,
            fileName,
            params: downLoadParams,
            downloadFunc: 'getCompareKeyMetrics',
            sheetName: 'Mentions & Sentiment',
          });
        }}
        logBtnId={'Mentions & Sentiment'}
      >
        <MentionsSentimentCharts
          filter={filter}
          tab={value}
          gameData={gameData}
          chartType={chartType}
          setSortBy={setSortBy}
          sortBy={sortBy}
        ></MentionsSentimentCharts>

        <MentionsSentimentTable
          filter={filter}
          tab={value}
          gameData={gameData}
        ></MentionsSentimentTable>
      </CardCommon>
    </CardCommon>
  );
}
